module.exports = __webpack_public_path__ + "static/working-memory-and-academic-learning-93d5ab92c5ef9c6db14d403ee594fb5a.jpg";